<table class="table aa-table">
    @for (row of block.content; track row) {
        <tr>
            <th scope="row">{{ row.data.label }}</th>
            <td>
                {{ block.data.chosenCurrency.currencySymbol ?? ''
                }}{{ getColumnData(row.data.chosenDataHeader) | number: '1.2-2' }}
            </td>
        </tr>
    }
</table>
